import {z} from 'zod';

export const SalesInquirySchema = z.object({
  name: z.string({error: 'Enter your name.'}).trim().min(1, 'Enter your name.').max(120, 'Use no more than 120 characters for your name.'),
  email: z.email({error: 'Enter a valid email address.'}).trim().max(254, 'Use no more than 254 characters for your email address.'),
  message: z.string({error: 'Enter a message.'}).trim().min(1, 'Enter a message.')
}).strict();

export const SALES_INQUIRY_SEND_ERROR = 'Your request could not be sent. Try again or email support@eightbots.com.';

export const SalesInquiryProblemSchema = z.object({
  code: z.enum(['contact_validation', 'contact_send_failed']),
  message: z.string().min(1).max(200)
}).strict();
